export default __webpack_public_path__ + "static/media/mobile-alert.236cbe52.jpg";